

export enum WhatsAppConnectionStatus {
    Undefined = 0,
    Online = 1,
    WaitingForQrCodeScan = 2,
    Initializing = 3,
    Ready = 4,
    Offline = 5
}